/**
 * Converts unitless or pixel values to ems.
 * @param {Number|String} value value to convert
 * @param {Number} base base font size
 */
export default function pxToEm(value) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  if (typeof value === 'string') {
    return value.indexOf('em') > -1 ? parseFloat(value) : parseFloat(value) / base;
  } else if (typeof value === 'number') {
    return value / base;
  } else {
    throw new Error("pxToEm: \"value\" must be a string or number. Type supplied: ".concat(typeof value));
  }
}